// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-02
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../redux/store";

// Hook for selecting Redux state.
const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
export default useReduxSelector;
